import { SearchRow } from './SearchRow';
import { recordKey, type SearchCluster, type SearchRecord } from './searchTypes';

// A household cluster (scope=all): the matched record leads, its people/dogs/
// stays nest beneath. A cluster with no members is a solo record — rendered as a
// plain row, not a card (matches the prototype). `activeKey` drives the keyboard
// highlight across the flattened row list.
export function ResultCluster({
  cluster,
  q,
  activeKey,
  onOpen,
}: {
  cluster: SearchCluster;
  q: string;
  activeKey: string | null;
  onOpen: (rec: SearchRecord) => void;
}) {
  const { header, members, moreBookings } = cluster;
  if (members.length === 0) {
    return <SearchRow rec={header} q={q} active={activeKey === recordKey(header)} onOpen={onOpen} />;
  }
  return (
    <div className="gs-cluster">
      <SearchRow rec={header} q={q} variant="header" active={activeKey === recordKey(header)} onOpen={onOpen} />
      <div className="gs-cl-members">
        {members.map((m) => (
          <SearchRow
            key={recordKey(m)}
            rec={m}
            q={q}
            variant="member"
            active={activeKey === recordKey(m)}
            onOpen={onOpen}
          />
        ))}
        {moreBookings ? (
          <div className="gs-more">
            +{moreBookings} more booking{moreBookings === 1 ? '' : 's'}
          </div>
        ) : null}
      </div>
    </div>
  );
}
